import React from 'react';
import { NavLink } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import { useAuth } from '../hooks/useAuth';

export default function Shell({
  title,
  children,
  wide,
}: {
  title: string;
  children: React.ReactNode;
  wide?: boolean;
}) {
  const { user, logout, isAdmin, hasEntitlement } = useAuth();
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `text-sm ${isActive ? 'text-navy-700 font-semibold' : 'text-ink-700 hover:text-ink-950'}`;
  const width = wide ? 'max-w-[1600px]' : 'max-w-6xl';

  return (
    <div className="min-h-screen bg-mist-50">
      <header className="border-b border-mist-200 bg-white">
        <div
          className={`mx-auto flex ${width} flex-wrap items-center justify-between gap-4 px-6 py-4`}
        >
          <div>
            <BrandLogo imgClassName="h-8 md:h-9" />
            <p className="mt-1 text-xs uppercase tracking-[0.18em] text-stone-500">
              {title}
            </p>
          </div>
          <nav className="flex flex-wrap items-center gap-4">
            <NavLink to="/portal" className={linkClass}>
              Funds
            </NavLink>
            {hasEntitlement('restructuring') && (
              <NavLink to="/portal/restructuring" className={linkClass}>
                Restructuring
              </NavLink>
            )}
            <NavLink to="/portal/interest" className={linkClass}>
              Express interest
            </NavLink>
            {isAdmin && (
              <>
                <NavLink to="/admin/crm" className={linkClass}>
                  CRM
                </NavLink>
                <NavLink to="/admin/users" className={linkClass}>
                  Users
                </NavLink>
                <NavLink to="/admin/interest" className={linkClass}>
                  Inbox
                </NavLink>
                <NavLink to="/admin/content" className={linkClass}>
                  Content
                </NavLink>
                <NavLink to="/admin/legal-bridge" className={linkClass}>
                  Legal docs
                </NavLink>
              </>
            )}
            <span className="text-xs text-ink-700">
              {user?.firstName} {user?.lastName}
            </span>
            <button
              type="button"
              onClick={logout}
              className="text-sm text-ink-700 underline"
            >
              Sign out
            </button>
          </nav>
        </div>
      </header>
      <main className={`mx-auto ${width} px-6 py-10`}>{children}</main>
      <footer
        className={`mx-auto ${width} px-6 pb-10 text-xs text-ink-700/80`}
      >
        Confidential materials for invited recipients. Not an offer to sell
        securities. Soft interest is non-binding.
      </footer>
    </div>
  );
}
